import React from 'react';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { AccountKeyNameFieldProps } from '@/types';

export default function AccountKeyNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  disabled = false,
}: AccountKeyNameFieldProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    if (setChanged) {
      setChanged();
    }
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Key name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Key name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Name'
          id='name'
          aria-describedby='name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={disabled}
          slotProps={{ inputLabel: { shrink: value?.length > 0 } }}
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter a name for the API key
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

